import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Kemper from "./pages/Kemper";
import Tonex from "./pages/Tonex";
import Nam from "./pages/Nam";
import Details from "./pages/Details";
import Imprint from "./pages/Imprint";
import Privacy from "./pages/Privacy";
import Carousel from "./components/Carousel";
import carouselImages from "./data/carouselImages"; // Import image data
import ScrollToTop from "./components/ScrollToTop"; // Import the component

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="bg-gray-900">
        <div id="main" className="flex flex-col min-h-screen font-roboto">
          <Carousel images={carouselImages} className=" max-h-1/6" />{" "}
          <Navigation />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/kemper" element={<Kemper />} />
              <Route path="/tonex" element={<Tonex />} />
              <Route path="/nam" element={<Nam />} />
              <Route path="/details/:id" element={<Details />} />
              <Route path="/imprint" element={<Imprint />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </div>
    </Router>
  );
};

export default App;
